/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Groups_DescriptionInputs */



/**
* | output |
* | --- |
* | "Form a private group with friends or your local store, with shared collections and trade matching that shows who has the cards you want." |
*
* @param {Nav_Locked_Groups_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_groups_description = /** @type {((inputs?: Nav_Locked_Groups_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Groups_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gründe eine private Gruppe mit Freunden oder deinem Laden, mit geteilten Sammlungen und Tausch-Matching, das zeigt, wer deine gesuchten Karten hat.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un groupe privé avec vos amis ou votre boutique, avec collections partagées et correspondances d'échange qui montrent qui a les cartes que vous cherchez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("与朋友或本地卡店组建私密小组，共享收藏并进行交换匹配，一眼看出谁有你想要的卡。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("和朋友或在地卡店組成私人社團，共用收藏並進行交易配對，看看誰有你想要的卡。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("친구나 동네 카드샵과 비공개 그룹을 만들어 컬렉션을 공유하고, 원하는 카드를 누가 가지고 있는지 교환 매칭으로 확인하세요.")
	return /** @type {LocalizedString} */ ("Form a private group with friends or your local store, with shared collections and trade matching that shows who has the cards you want.")
});